import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { rootRouteRef } from './routes';

export const statusEntityCard = EntityCardBlueprint.make({
  name: 'status',
  disabled: true,
  params: {
    type: 'info',
    loader: async () =>
      import('./components/EntityStatusCard').then(m => <m.EntityStatusCard />),
  },
});

export const systemStatusPlugin = createFrontendPlugin({
  pluginId: 'system-status',
  extensions: [statusEntityCard],
  routes: {
    root: rootRouteRef,
  },
});
